import { debounce, isEqualWith } from "lodash-es";
import moment from "moment";
import React from "react";
export const customizerWithDates = (v1, v2) => {
    if (v1 instanceof moment && v2 instanceof moment) {
        return v1.valueOf() === v2.valueOf();
    }
    if (v1 instanceof Date && v2 instanceof Date) {
        return v1.valueOf() === v2.valueOf();
    }
};
export const defaultIsEqualValues = (v1, v2) => {
    return isEqualWith(v1, v2, customizerWithDates);
};
export const useDebouncedSync = ({ debounceMs = 500, externalValue, setExternalValue, isEqualValues = defaultIsEqualValues, }) => {
    const [internalValue, setInternalValue] = React.useState(externalValue);
    const latestInternalValue = React.useRef(internalValue);
    latestInternalValue.current = internalValue;
    const latestExternalValue = React.useRef(externalValue);
    latestExternalValue.current = externalValue;
    const latestSyncedValue = React.useRef(undefined);
    const latestPreviousValue = React.useRef(undefined);
    const latestRef = React.useRef({ setExternalValue, isEqualValues });
    latestRef.current = { setExternalValue, isEqualValues };
    const needSync = React.useRef(false);
    const syncWithExternalValue = React.useCallback(debounce((newValue) => {
        if (latestSyncedValue.current !== undefined) {
            needSync.current = true;
            return;
        }
        latestPreviousValue.current = latestExternalValue.current;
        latestSyncedValue.current = newValue;
        latestRef.current.setExternalValue(newValue);
    }, debounceMs, {
        leading: false,
        trailing: true,
    }), [debounceMs]);
    const setInternalValueWithSync = React.useCallback((newValue) => {
        setInternalValue(newValue);
        syncWithExternalValue(newValue);
    }, [syncWithExternalValue]);
    React.useEffect(() => {
        if (latestSyncedValue.current !== undefined) {
            if (latestPreviousValue.current !== undefined &&
                latestRef.current.isEqualValues(latestPreviousValue.current, externalValue)) {
                return;
            }
            if (!latestRef.current.isEqualValues(latestSyncedValue.current, externalValue)) {
                setInternalValue(externalValue);
            }
            latestSyncedValue.current = undefined;
            latestPreviousValue.current = undefined;
        }
        else {
            if (!latestRef.current.isEqualValues(latestInternalValue.current, externalValue)) {
                setInternalValue(externalValue);
            }
        }
        if (needSync.current) {
            setTimeout(() => {
                syncWithExternalValue(latestInternalValue.current);
            });
            needSync.current = false;
        }
    }, [externalValue, syncWithExternalValue]);
    return [internalValue, setInternalValueWithSync];
};
//# sourceMappingURL=useDebouncedSync.js.map